import { render } from "./ReferenceSearchView.vue?vue&type=template&id=7be948b6"
import script from "./ReferenceSearchView.vue?vue&type=script&lang=js"
export * from "./ReferenceSearchView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__